<div class="modal-header">
    <h5 class="modal-title">{{tituloModal}}</h5>
    <button type="button" class="close" data-dismiss="modal" (click)="cerrarModal()">X</button>
</div>
<div class="modal-body">
    <div class="row" id="body" [innerHTML]="informacionArchivo">
    </div>
</div>
<div class="modal-footer">
</div>